import styled from 'styled-components';

export const Tags = styled(({ className, children }) => {
  return <div className={className}>{children}</div>;
})`
  display: flex;
  gap: 4px;
  margin-bottom: 8px;
  flex-wrap: wrap;
  align-content: flex-start;
`;
